import React, { useContext } from "react";
import { Container, Grid, Box } from "@mui/material";
import CcpSchoolBreadCrumbs from "../../Layout/CcpSchoolBreadCrumbs";
import AdditionalRegReport from "./inc/AdditionalRegReport";
import AdditionalGradeReport from "./inc/AdditionalGradeReport";
import AdditionalGradeReport2 from "./inc/AdditionalGradeReport2";
import GradeReport from "./inc/GradeReport";
import RegReport from "./inc/RegReport";
import { SchoolContext } from "../../../config/SchoolContext";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@mui/material/styles";

const CcpSchoolReports = () => {
  const { schoolId } = useContext(SchoolContext);
  const pageName = "School Reports";
  const icon = faChartBar;
  const theme = useTheme();
  const linkColor = theme.palette.mode === "dark" ? "white" : "black";

  return (
    <>
      <Container sx={{ marginTop: "100px" }}>
        <Box sx={{ flexGrow: 1 }}>
          <CcpSchoolBreadCrumbs pageName={pageName} icon={icon} />
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <h4>School Reports</h4>
            </Grid>
            <Grid item xs={12}></Grid>
          </Grid>
        </Box>
      </Container>

      {/* Full-width reports outside container */}
      <Box sx={{ width: "100%", px: 2, pb: 2 }}>
        <RegReport schoolId={schoolId} />
      </Box>
      <Box sx={{ width: "100%", px: 2, pb: 2 }}>
        <GradeReport schoolId={schoolId} />
      </Box>

      <Container>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <AdditionalRegReport schoolId={schoolId} linkColor={linkColor} />
          </Grid>
          <Grid item xs={4}>
            <AdditionalGradeReport schoolId={schoolId} linkColor={linkColor} />
          </Grid>
          <Grid item xs={4}>
            <AdditionalGradeReport2 schoolId={schoolId} linkColor={linkColor} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CcpSchoolReports;
